import { SKIP_MONTH as content } from '@genoa/screen-content'
import { Flex } from '@chakra-ui/react'
import styled from '@emotion/styled'

import { Gap, Headline2, InlineButton, PrimaryButton, SmallText } from '../../../../../components'
import { Modal } from '../../../../../components/Modal'

type SkipMonthModalProps = {
  loading: boolean
  onClose: () => unknown
  onSubmit: () => unknown
  visible: boolean
}

export const SkipMonthModal = (props: SkipMonthModalProps) => (
  <Modal canClose={!props.loading} onClose={props.onClose} testID="SkipMonthModal" title="" visible={props.visible}>
    <Container>
      <Headline2>{content.HEADER}</Headline2>
      <Gap size="spacing_100" />
      <SmallText>{content.BODY1}</SmallText>
      <SmallText fontWeight="bold">{content.BODY2}</SmallText>
      <Gap size="spacing_100" />
      <SmallText>{content.BODY3}</SmallText>
      <Gap size="spacing_100" />
      <SmallText>{content.BODY4}</SmallText>
      <SmallText fontWeight="bold">{content.BODY5}</SmallText>
      <Gap size="spacing_100" />
      <BackButton disabled={props.loading} onClick={props.onClose} testID="SkipMonthBackButton">
        {content.BACK}
      </BackButton>
      <PrimaryButton onClick={props.onSubmit} processing={props.loading} testID="SkipMonthConfirmationButton">
        {content.CONFIRM}
      </PrimaryButton>
    </Container>
  </Modal>
)

const BackButton = styled(InlineButton)`
  align-self: center;
  color: ${({ theme }) => theme.colors.jewelPurple};
  font-size: 18px;
  font-weight: ${(props) => props.theme.fontWeights.bold};
  line-height: ${({ theme }) => theme.fontSizes.lg};
  margin-top: ${({ theme }) => theme.fixedSizes.spacing_150};
  padding-bottom: ${({ theme }) => theme.fixedSizes.spacing_150};
`

const Container = styled(Flex)`
  flex-direction: column;
`
